// batchPusherEvents.js

import {
  CHAT_USER_ENTERED,
  CHAT_MESSAGE_SENT,
  GIFT_SENT,
  SIC_BO_CREATED,
  SIC_BO_ENDED,
  SESSION_RATED,
  LIVESTREAM_CHAT_UNPINNED,
} from '../serviceWorker/PusherEvents.js';

// High-frequency pusher event types whose payloads carry `batchedData`
// arrays. Single source of truth shared by the service worker frame batching
// (pusherController) and the app-side time-window merging.
export const BATCHED_PUSHER_EVENT_TYPES = [
  CHAT_USER_ENTERED,
  CHAT_MESSAGE_SENT,
  GIFT_SENT,
  SIC_BO_CREATED,
  SIC_BO_ENDED,
  SESSION_RATED,
  LIVESTREAM_CHAT_UNPINNED,
];

/**
 * Batch specific event data into an array by event names
 * @param {[string} types - event names need to batch
 * @param {[object]} events - origin events from pusher
 * @param {[object]} events
 */
export const batchPusherEvents = ({ types = [], events = [] }) => {
  if (!types?.length) return events;

  let tempBatchedData = {};
  const filteredEvents = events.reduce((accu, curr) => {
    if (types.includes(curr.event)) {
      if (!tempBatchedData[curr.event]) tempBatchedData[curr.event] = [];
      tempBatchedData[curr.event].push(curr.data);
    } else accu.push(curr);

    return accu;
  }, []);
  return [
    ...filteredEvents,
    ...types
      .filter(type => tempBatchedData?.[type]?.length)
      .map(type => {
        return {
          event: type,
          data: {
            batchedData: tempBatchedData[type],
          },
        };
      }),
  ];
};

export default batchPusherEvents;
